import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import CustomSelect from 'shared/lib/components/controls/selects/customSelect';
import { SortContentOrder } from 'entities/types';
import MenuHeader from 'shared/lib/components/menu/menuHeader';
import CommonMenuItem from 'shared/lib/components/menu/commonMenuItem';
import ArrowUp from 'shared/icons/arrows/arrowUp';
import ArrowDown from 'shared/icons/arrows/arrowDown';

const sortOrderItems = [
  { id: SortContentOrder.ASC, name: 'По возрастанию' },
  { id: SortContentOrder.DESC, name: 'По убыванию' },
];

export type SortingControlProps = {
  value: SortContentOrder;
  onChange: (value: SortContentOrder) => void;
  sx?: SxProps;
};

export default function SortOrderSelect({
  value,
  onChange,
  sx,
}: SortingControlProps) {
  return (
    <CustomSelect
      value={value}
      items={sortOrderItems}
      onChange={onChange}
      sx={sx}
      renderItems={() => {
        return [
          <MenuHeader key="header" text="Тип сортировки"></MenuHeader>,
          <CommonMenuItem
            sx={{ display: 'flex', alignItems: 'center' }}
            key={SortContentOrder.ASC}
            value={SortContentOrder.ASC}
          >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <ArrowUp sizeKey="16x16"></ArrowUp>
              <Typography variant="f16">По возрастанию</Typography>
            </Box>
          </CommonMenuItem>,
          <CommonMenuItem
            sx={{ display: 'flex', alignItems: 'center' }}
            key={SortContentOrder.DESC}
            value={SortContentOrder.DESC}
          >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <ArrowDown sizeKey="16x16"></ArrowDown>
              <Typography variant="f16">По убыванию</Typography>
            </Box>
          </CommonMenuItem>,
        ];
      }}
    ></CustomSelect>
  );
}
